import React, { useState, useEffect, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import Accordion from '@mui/material/Accordion';
import { Button, TextField, Card, Grid, CardHeader, CardContent, IconButton, Tooltip, Paper, Input } from '@mui/material';
import { SelectField } from 'components';
import DatePicker from 'components/DatePicker/DatePicker';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';
import { enqueueSnackbar } from 'actions';
import ModalDialog from '../../../../../../components/ModalDialog/ModalDialog.js';
import {
	SetFormState, GetSiteDropdowns, GetSitesIds, ToggleSiteTrackerUpdateConfirmation
} from '../../../../actions/SiteTrackerActions';
import SiteTrackerUpdateConfirmation from './SiteTrackerUpdateConfirmation';

const SiteTrackerUpdateForm = (props) => {
	const { open, dropdownLabel, dropdownName, dropdownValue, dropdownId, ...rest } = props;
	const dispatch = useDispatch();
	const tableId = useSelector((state) => state.siteTrackerReducer.tableId);
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector(state => state.siteTrackerReducer.formState);
	const dropdowns = useSelector(state => state.siteTrackerReducer.dropdowns);
	const sitesIds = useSelector(state => state.siteTrackerReducer.sitesIds);
	const siteTrackerUpdateConfirmationVisibility = useSelector(state => state.siteTrackerReducer.siteTrackerUpdateConfirmationVisibility);
	const fieldType = useSelector(state => state.siteTrackerReducer.fieldType);
	const fieldTypeValue = useSelector(state => state.siteTrackerReducer.fieldTypeValue);
	const fieldName = useSelector(state => state.siteTrackerReducer.fieldName);
	const fieldValue = useSelector(state => state.siteTrackerReducer.fieldValue);
	const phase = useSelector(state => state.siteTrackerReducer.phase);

	const [expanded, setExpanded] = useState(false);

	const handleChangePanel = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	const getData = useCallback(() => {
		dispatch(GetSiteDropdowns());
	}, []);

	useEffect(() => {
		getData();
	}, []);

	const _handleChange = event => {

		setFormState({
			...formState,
			values: {
				...formState.values,
				[event.target.name]:
					event.target.type === 'checkbox'
						? event.target.checked
						: event.target.value
			},
			touched: {
				...formState.touched,
				[event.target.name]: true
			}
		});

		if (event.target.name === 'phase') {
			dispatch(GetSitesIds(formState.values.mocnActivationDateF, event.target.value));
		} else if (event.target.name === 'mocnActivationDateF' && formState.values.phase !== undefined) {
			dispatch(GetSitesIds(event.target.value, formState.values.phase));
		}
	};

	const _handleDateChange = (value, name, type = 'date') => {
		let formattedValue = null;

		if (value) {
			if (type === 'date') {
				formattedValue = value.startOf('day').format('YYYY-MM-DD');
			} else {
				formattedValue = value.format('YYYY-MM-DD HH:mm:ss');
			}
		}

		setFormState({
			...formState,
			values: {
				...formState.values,
				[name]: formattedValue
			},
			touched: {
				...formState.touched,
				[name]: true
			}
		});
	};

	const _handleSave = (fieldType, fieldTypeValue, fieldName, fieldValue, phase) => {
		// dispatch(enqueueSnackbar({ message: 'Please select valeus/options', options: { variant: 'warning' } }));
		dispatch(ToggleSiteTrackerUpdateConfirmation(true, fieldType, fieldTypeValue, fieldName, fieldValue, phase));
	};

	return (
		<div
			style={{ marginTop: '10px' }}
		>
			<Accordion expanded={expanded === 'panel1'} onChange={handleChangePanel('panel1')}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel1bh-content"
					id="panel1bh-header"
					className='highlight'
				>
					<Typography sx={{ width: '33%', flexShrink: 0 }}>Update Per Cluster Name</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<br />
					<Grid container spacing={1}>
						<Grid item md={4} xs={4}>
							<SelectField
								id="clusterName"
								name="clusterName"
								hintText="Cluster Name"
								defaultValue=""
								menuItems={(dropdowns && dropdowns.clusterName) || []}
								value={formState.values.clusterName}
								onChange={_handleChange}
							/>
						</Grid>
						<Grid item md={3} xs={3}>
							<DatePicker
								id="mocnActivationDateF"
								name="mocnActivationDateF"
								label="MOCN Activation Date (F)"
								value={formState.values.mocnActivationDateF}
								onChange={value => _handleDateChange(value, 'mocnActivationDateF')}
								format="DD/MM/YYYY"
								disabled={formState.values.clusterName === undefined}
							/>
						</Grid>
						<Grid item md={4} xs={4}>
							<TextField
								id="note"
								name="note"
								label="Note"
								variant="outlined"
								fullWidth
								value={'For all Cluster'}
								onChange={_handleChange}
								sx={{
									'& .MuiInputBase-input': {
										backgroundColor: 'white',
										'&.Mui-disabled': {
											color: 'dimGray',
											WebkitTextFillColor: 'dimGray'
										}
									},
								}}
								disabled
							/>
						</Grid>
						<Grid item md={1} xs={1}>
							<Button
								color="primary"
								onClick={() => _handleSave('clusterName', formState.values.clusterName, 'mocnActivationDateF', formState.values.mocnActivationDateF)}
								variant="contained"
								disabled={formState.values.clusterName === undefined || formState.values.mocnActivationDateF === undefined}
							>
								Save
							</Button>
						</Grid>
					</Grid>
					<br />
					<Grid container spacing={1}>
						<Grid item md={4} xs={4}>
							<SelectField
								id="clusterName"
								name="clusterName"
								hintText="Cluster Name"
								defaultValue=""
								menuItems={(dropdowns && dropdowns.clusterName) || []}
								value={formState.values.clusterName}
								onChange={_handleChange}
							/>
						</Grid>
						<Grid item md={3} xs={3}>
							<DatePicker
								id="mocnActivationDateA"
								name="mocnActivationDateA"
								label="MOCN Activation Date (A)"
								value={formState.values.mocnActivationDateA}
								onChange={value => _handleDateChange(value, 'mocnActivationDateA')}
								format="DD/MM/YYYY"
								disabled={formState.values.clusterName === undefined}
							/>
						</Grid>
						<Grid item md={4} xs={4}>
							<TextField
								id="note"
								name="note"
								label="Note"
								variant="outlined"
								fullWidth
								value={'For Dates empty and Status Scheduled'}
								onChange={_handleChange}
								sx={{
									'& .MuiInputBase-input': {
										backgroundColor: 'white',
										'&.Mui-disabled': {
											color: 'dimGray',
											WebkitTextFillColor: 'dimGray'
										}
									},
								}}
								disabled
							/>
						</Grid>
						<Grid item md={1} xs={1}>
							<Button
								color="primary"
								onClick={() => _handleSave('clusterName', formState.values.clusterName, 'mocnActivationDateA', formState.values.mocnActivationDateA)}
								variant="contained"
								disabled={formState.values.clusterName === undefined || formState.values.mocnActivationDateA === undefined}
							>
								Save
							</Button>
						</Grid>
					</Grid>
					<br />
					<Grid container spacing={1}>
						<Grid item md={4} xs={4}>
							<SelectField
								id="clusterName"
								name="clusterName"
								hintText="Cluster Name"
								defaultValue=""
								menuItems={(dropdowns && dropdowns.clusterName) || []}
								value={formState.values.clusterName}
								onChange={_handleChange}
							/>
						</Grid>
						<Grid item md={3} xs={3}>
							<SelectField
								id="mocnActivationStatus"
								name="mocnActivationStatus"
								hintText="MOCN Activation Status"
								defaultValue=""
								menuItems={(dropdowns && dropdowns.mocnActivationStatus) || []}
								value={formState.values.mocnActivationStatus}
								onChange={_handleChange}
								disabled={formState.values.clusterName === undefined}
							/>
						</Grid>
						<Grid item md={4} xs={4}>
							<TextField
								id="note"
								name="note"
								label="Note"
								variant="outlined"
								fullWidth
								value={'For all Status empty'}
								onChange={_handleChange}
								sx={{
									'& .MuiInputBase-input': {
										backgroundColor: 'white',
										'&.Mui-disabled': {
											color: 'dimGray',
											WebkitTextFillColor: 'dimGray'
										}
									},
								}}
								disabled
							/>
						</Grid>
						<Grid item md={1} xs={1}>
							<Button
								color="primary"
								onClick={() => _handleSave('clusterName', formState.values.clusterName, 'mocnActivationStatus', formState.values.mocnActivationStatus)}
								variant="contained"
								disabled={formState.values.clusterName === undefined || formState.values.mocnActivationStatus === undefined}
							>
								Save
							</Button>
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>
			{/* Per Date and Phase */}
			<Accordion expanded={expanded === 'panel2'} onChange={handleChangePanel('panel2')} disabled>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel2bh-content"
					id="panel2bh-header"
					className='highlight'
				>
					<Typography sx={{ width: '33%', flexShrink: 0 }}>Update Date and Phase</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<br />
					<Grid container spacing={1}>
						<Grid item md={3} xs={3}>
							<SelectField
								id="mocnActivationDateF"
								name="mocnActivationDateF"
								hintText="MOCN ActivationDate (F)"
								defaultValue=""
								menuItems={(dropdowns && dropdowns.mocnActivationDateF) || []}
								value={formState.values.mocnActivationDateF}
								onChange={_handleChange}
							/>
						</Grid>
						<Grid item md={2} xs={2}>
							<SelectField
								id="phase"
								name="phase"
								hintText="Phase"
								defaultValue=""
								menuItems={(dropdowns && dropdowns.phase) || []}
								value={formState.values.phase}
								onChange={_handleChange}
								disabled={formState.values.mocnActivationDateF === undefined}
							/>
						</Grid>
						<Grid item md={3} xs={3}>
							<DatePicker
								id="mocnActivationDateA"
								name="mocnActivationDateA"
								label="MOCN Activation Date (A)"
								value={formState.values.mocnActivationDateA}
								onChange={value => _handleDateChange(value, 'mocnActivationDateA')}
								format="DD/MM/YYYY"
								disabled={formState.values.phase === undefined}
							/>
						</Grid>
						<Grid item md={3} xs={3}>
							<TextField
								id="note"
								name="note"
								label="Note"
								variant="outlined"
								fullWidth
								value={'Notes'}
								onChange={_handleChange}
								sx={{
									'& .MuiInputBase-input': {
										backgroundColor: 'white',
										'&.Mui-disabled': {
											color: 'dimGray',
											WebkitTextFillColor: 'dimGray'
										}
									},
								}}
								disabled
							/>
						</Grid>
						<Grid item md={1} xs={1}>
							<Button
								color="primary"
								onClick={() => _handleSave(
									'mocnActivationDateF', formState.values.mocnActivationDateF,
									'mocnActivationDateA', formState.values.mocnActivationDateA,
									formState.values.phase
								)}
								variant="contained"
								disabled={formState.values.mocnActivationDateF === undefined || formState.values.mocnActivationDateA === undefined}
							>
								Save
							</Button>
						</Grid>
					</Grid>
					<br />
					<Grid container spacing={1}>
						<Grid item md={3} xs={3}>
							<SelectField
								id="mocnActivationDateF"
								name="mocnActivationDateF"
								hintText="MOCN ActivationDate (F)"
								defaultValue=""
								menuItems={(dropdowns && dropdowns.mocnActivationDateF) || []}
								value={formState.values.mocnActivationDateF}
								onChange={_handleChange}
							/>
						</Grid>
						<Grid item md={2} xs={2}>
							<SelectField
								id="phase"
								name="phase"
								hintText="Phase"
								defaultValue=""
								menuItems={(dropdowns && dropdowns.phase) || []}
								value={formState.values.phase}
								onChange={_handleChange}
								disabled={formState.values.mocnActivationDateF === undefined}
							/>
						</Grid>
						<Grid item md={3} xs={3}>
							<SelectField
								id="mocnActivationStatus"
								name="mocnActivationStatus"
								hintText="MOCN Activation Status"
								defaultValue=""
								menuItems={(dropdowns && dropdowns.mocnActivationStatus) || []}
								value={formState.values.mocnActivationStatus}
								onChange={_handleChange}
								disabled={formState.values.phase === undefined}
							/>
						</Grid>
						<Grid item md={3} xs={3}>
							<TextField
								id="note"
								name="note"
								label="Note"
								variant="outlined"
								fullWidth
								value={'Notes'}
								onChange={_handleChange}
								sx={{
									'& .MuiInputBase-input': {
										backgroundColor: 'white',
										'&.Mui-disabled': {
											color: 'dimGray',
											WebkitTextFillColor: 'dimGray'
										}
									},
								}}
								disabled
							/>
						</Grid>
						<Grid item md={1} xs={1}>
							<Button
								color="primary"
								onClick={() => _handleSave('mocnActivationDateF', formState.values.clusterName, 'mocnActivationDateF', formState.values.mocnActivationDateF)}
								variant="contained"
								disabled={formState.values.mocnActivationDateF === undefined || formState.values.mocnActivationStatus === undefined}
							>
								Save
							</Button>
						</Grid>
					</Grid>
					<br />
					<Grid container spacing={1}>
						<Grid item md={12} xs={12}>
							<Paper>
								<TextField
									value={sitesIds}
									placeholder="Sites affected"
									fullWidth
									multiline
									minRows={sitesIds.length === 0 ? 1 : 4}
									maxRows={10}
									variant="standard" // ou "outlined"
								/>
							</Paper>
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>
			<Accordion expanded={expanded === 'panel3'} onChange={handleChangePanel('panel3')} disabled>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					aria-controls="panel3bh-content"
					id="panel3bh-header"
					className='highlight'
				>
					<Typography sx={{ width: '33%', flexShrink: 0 }}>Update Per Site</Typography>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container spacing={1}>
						<Grid item md={3} xs={3}>
							{/* <Paper className={classes.paper} elevation={1}>
								<Input
									value={commentValue}
									className={classes.input}
									disableUnderline
									onChange={_handleCommentInputChange}
									placeholder="Type a comment"
								/>
							</Paper> */}
						</Grid>
					</Grid>
				</AccordionDetails>
			</Accordion>
			{siteTrackerUpdateConfirmationVisibility && (
				<SiteTrackerUpdateConfirmation
					open={siteTrackerUpdateConfirmationVisibility}
					fieldType={fieldType}
					fieldTypeValue={fieldTypeValue}
					fieldName={fieldName}
					fieldValue={fieldValue}
					phase={phase}
				/>
			)}
		</div>
	);
};

SiteTrackerUpdateForm.propTypes = {
	open: PropTypes.bool
};

export default SiteTrackerUpdateForm;
